const getCellText = ({ cellThreatLimit, displayValue }) => {
    if (cellThreatLimit && !cellThreatLimit.showValue) {
        return '';
    } else {
        return displayValue.displayValue || '-';
    }
};

export default getCellText;
